import { render, staticRenderFns } from "./offiaccountDailog.vue?vue&type=template&id=47c76474"
import script from "./offiaccountDailog.vue?vue&type=script&lang=js"
export * from "./offiaccountDailog.vue?vue&type=script&lang=js"
import style0 from "./offiaccountDailog.vue?vue&type=style&index=0&id=47c76474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports